import * as z from 'zod/v4';

import type { Currency } from '../lib/entry.js';

/**
 * Available wallet ids in tipsen products
 */
export type WalletId = 'WALLET_ID_PLAYER' | 'WALLET_ID_MARKETPLACE_RETAILER' | 'WALLET_ID_SELFSERVICE';

export const walletTypeSchema = z.enum([
  'WALLET_PLAYER',
  'WALLET_MARKETPLACE_PLAYER',
  'WALLET_MARKETPLACE_RETAILER',
  'WALLET_SELFSERVICE',
]);

/**
 * Available wallet types in tipsen products
 */
export type WalletType = z.infer<typeof walletTypeSchema>;

/**
 * Wallet metadata entity
 */
export type Wallet = {
  id: WalletId;
  type: WalletType;
  label: string;
  meta: {
    balance: Currency;
  };
};
